import axios from "axios";
import env from "../variables/EndpointEnvironment";

const SBDKAPI = () => {
  return axios.get(`${env.HOST}/sbdk`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default SBDKAPI;
